'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 17, height: 17, viewBox: "0 0 17 17", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M7.469 3.434a.8.8 0 0 1 1.091 1.17L5.084 7.848l-.37.347h10.38a.8.8 0 0 1 0 1.6H4.667q.178.17.417.393l3.434 3.204a.8.8 0 1 1-1.092 1.17l-3.471-3.24c-.409-.38-.773-.721-1.029-1.035-.277-.341-.51-.75-.51-1.27s.233-.927.51-1.269c.256-.314.62-.654 1.029-1.035z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
